import React, {useState, useEffect, useContext} from "react";
import EditablePdf from "../../../components/forms/EditablePdf";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
import SessionGenerator from "./sessions/SessionGenerator";
import {Input, Label} from "../../../components/forms/DynamicInput";
import EditableImg from "../../../components/forms/EditableImg";
import {AppButton, ResetButton} from "../../../styles/Butttons";
import nextId from "react-id-generator";
import MediaCreator from "./media/MediaCreator";
import {CreateResourceCourse} from "../../../services/GeneralServices";
import AppLoader, {LoadComponet} from "../../../components/loaders/Loader";
import {EditCourseContext} from "../../../context/EditCourseProvider";
import {DeleteResource} from "../../../services/CoursesServices";
import {useParams} from "react-router-dom";

const FormPartTwo = React.forwardRef((props, ref) => {
   const {mediaCourse, docsCourse, getMediaData, deleteDoc} = useContext(EditCourseContext);
   const [newPdf, setPdf] = useState({file: "", name: ""});
   const [isSaving, setSaving] = useState(false);
   let {isVisible} = props;
   let {id} = useParams();

   useEffect(() => {
      if (isVisible) {
         getMediaData();
      }
   }, [isVisible]);

   const savePdf = () => {
      if (!newPdf.file) {
         return props.continueAction();
      }
      setSaving(true);
      let newData = new FormData();
      newData.append("idCourse", id);
      newData.append("resourceName", newPdf.name || "PDF del curso");
      newData.append("token", localStorage.getItem("domecq_token"));
      newData.append("pathResource", newPdf.file.files[0]);

      CreateResourceCourse(newData)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setSaving(false);
         })
         .then(() => {
            // props.continueAction();
         })
         .catch((e) => {
            setSaving(false);
            console.log(e);
         });
   };

   const deletePdf = (id) => {
      setSaving(true);
      DeleteResource(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            deleteDoc(id);
         })
         .then(() => setSaving(false))
         .catch((e) => {
            setSaving(false);
            console.log(e);
         });
   };

   return (
      <>
         <AllGrid>
            <Col large={12}>
               <TitleSecion>Descargable y vídeos:</TitleSecion>
            </Col>
            <Col large={12}>
               {docsCourse.isLoading ? (
                  <LoadComponet />
               ) : docsCourse.data.length > 0 ? (
                  React.Children.toArray(
                     docsCourse.data.map((item) => {
                        return (
                           <Grid>
                              <Label>Recurso PDF descargable:</Label>
                              <MediaCol large={5} className="column">
                                 <Input
                                    placeholder="Nombre del archivo"
                                    defaultValue={item.resourceName || ""}
                                    onChange={(e) => setPdf({...newPdf, name: e.target.value})}
                                 />
                                 <EditablePdf
                                    change={(e) => setPdf({...newPdf, file: e.target})}
                                    fileName={item.pathResource || ""}
                                    editable={true}
                                    name="resoursePdf"
                                    removeAction={() => deletePdf(item.idResource)}
                                 />
                              </MediaCol>
                           </Grid>
                        );
                     }),
                  )
               ) : (
                  <Grid>
                     <Label>Recurso PDF descargable:</Label>
                     <MediaCol large={5} className="column">
                        <Input placeholder="Nombre del archivo" onChange={(e) => setPdf({...newPdf, name: e.target.value})} />
                        <EditablePdf change={(e) => setPdf({...newPdf, file: e.target})} editable={true} name="resoursePdf" />
                     </MediaCol>
                  </Grid>
               )}
            </Col>
            {mediaCourse.isLoading ? (
               <LoadComponet />
            ) : (
               <MediaCreator isVisible={props.isVisible} continueAction={savePdf} idCourse={props.idCourse} savePdf={savePdf} />
            )}
         </AllGrid>
         <AppLoader isVisible={isSaving} />
      </>
   );
});

export default FormPartTwo;

const AllGrid = styled(Grid)`
   .sepTop {
      margin-top: 2em;
   }
`;

const TitleSecion = styled.p`
   font-size: 1.5em;
   font-weight: 400;
   color: #1c355e;
   margin: 1em 0 1.5em 0;
`;

const MediaCol = styled(Col)`
   display: flex;
   align-items: flex-end;

  &.column {
      align-items: flex-start;
      flex-direction: column;
   } 

   & ${ResetButton} {
      width: auto;
      padding: 0.3em 0.5em;
      height: fit-content;
      color: crimson;
   }

   .row {
      width: 90%;
   }

   &.sepTop {
      margin-top: 1em;
   }
`;

const Title = styled.p``;

const ClasesText = styled.textarea`
   font-size: 1em;
   font-family: Montserrat;
   resize: none;
   width: 100%;
   height: 120px;
   margin: 0.5em 0;
`;
